import http from "../http-common";

class TaxonomyProductService {
  getTaxonomyProductList(productPath: string) {
    return http.get(`/taxonomy/product/${productPath}`);
  }
}

export default new TaxonomyProductService();
